var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(_vm._s(_vm.value.toLocaleString(_vm.$i18n.locale, { maximumFractionDigits: 2, minimumFractionDigits: 2 })))])
}
var staticRenderFns = []

export { render, staticRenderFns }